import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({  providedIn: 'root',})export class LoaderService {
  private loaderSubject: BehaviorSubject<boolean> = new  BehaviorSubject<boolean>(null);
  loader$: Observable<boolean>;
  
  constructor() { 
    this.loader$ = this.loaderSubject.asObservable(); 
   }
   triggerLoader(value) {
    this.loaderSubject.next(value);
   }
   clearMessage() {
    this.loaderSubject.next(null);
   }
  }
